function App() {
  return (
    <div style={{
      backgroundColor: '#111',
      color: '#00ffcc',
      fontSize: '48px',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      hi.inwave
    </div>
  );
}

export default App;
